<script>
  export default {
    name: 'analyticFormatData',
    methods: {
      date(period) {
        const timeFormat = 'hh:mm'
        const fullTimeFormat = 'hh:mm:ss'
        const dateFormat = 'YYYY-MM-DD'
        const currentDay = this.$moment().format(dateFormat)

        return {
          today: currentDay,
          time: this.$moment().format(timeFormat),
          fullTime: this.$moment().format(fullTimeFormat),
          lastWeek: this.$moment().subtract(1,'w').format(dateFormat),
          lastMonth: this.$moment().subtract(1,'month').format(dateFormat),
          lastYear: this.$moment().subtract(1,'year').format(dateFormat),
          currentWeek: this.$moment(currentDay).startOf('isoWeek').format(dateFormat),
          currentMonth: this.$moment(currentDay).startOf('month').format(dateFormat),
          currentYear: this.$moment(currentDay).startOf('year').format(dateFormat),
          getMonthName: this.$moment(period).format('MMM')
        }
      },
      handleMinMaxDatePicker(date) {
        return date > new Date() || date < new Date('2016-01-01')
      },
      chunked(arr, len) {
        let i = 0
        const chunks = []

        while (i < arr.length) {
          chunks.push(arr.slice(i, i += len))
        }

        return chunks
      }
    }
  }
</script>
